import React, { useState } from "react";
import { api } from "../../lib/api";
import { Avatar } from "../common";
import { UserPlus, Radio, Plus, X, Shield, Settings } from "lucide-react";

export default function Inspector({ channel, campaign, npcs, characters, onChanged, onNewNpc, onToggleReveal }) {
  const [addType, setAddType] = useState("");

  if (!channel) {
    return (
      <div className="p-4">
        <div className="sys-label mb-3">PARAMÈTRES CAMPAGNE</div>
        <div className="frame p-3 mb-3">
          <div className="sys-label">UNIVERS</div>
          <div className="font-semibold mt-1">{campaign?.resolved?.universe_name}</div>
          <div className="font-semibold">{campaign?.name}</div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div className="frame p-3 text-center"><div className="font-title font-black text-2xl" style={{ color: "var(--r-primary)" }}>{campaign?.players ?? 0}</div><div className="sys-label">JOUEURS</div></div>
          <div className="frame p-3 text-center"><div className="font-title font-black text-2xl" style={{ color: "var(--r-secondary)" }}>{campaign?.npcs ?? 0}</div><div className="sys-label">PNJ</div></div>
        </div>
      </div>
    );
  }

  const partIds = (channel.participants_view || []).map((p) => p.id);
  const availNpcs = npcs.filter((n) => !partIds.includes(n.id) && n.is_active);
  const availChars = characters.filter((c) => !partIds.includes(c.id));

  async function addParticipant(id, kind) {
    const body = kind === "npc" ? { npc_ids: [id] } : { character_ids: [id] };
    await api.patch(`/channels/${channel.id}`, body);
    onChanged?.();
  }
  async function removeParticipant(id) {
    await api.patch(`/channels/${channel.id}`, { remove_participant: id });
    onChanged?.();
  }

  return (
    <div className="p-4 overflow-y-auto h-full">
      <div className="sys-label mb-2 flex items-center gap-2"><Shield size={12} /> CANAL</div>
      <div className="frame p-3 mb-4">
        <div className="font-semibold">{channel.name}</div>
        <div className="sys-label mt-1">{channel.type}</div>
      </div>

      <div className="flex items-center justify-between mb-2">
        <div className="sys-label">PARTICIPANTS</div>
        <button data-testid="new-npc-inline-button" onClick={onNewNpc} className="sys-label flex items-center gap-1 hover:text-[color:var(--r-primary)]"><Plus size={11} /> PNJ</button>
      </div>
      <div className="space-y-1.5 mb-4">
        {(channel.participants_view || []).map((p) => (
          <div key={p.id} className="flex items-center gap-2 p-2 frame">
            <Avatar src={p.avatar} name={p.name} size={30} />
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{p.name}</div>
              <div className="sys-label">{p.type === "npc" ? "PNJ" : "PERSONNAGE"}{!p.can_write ? " · LECTURE" : ""}</div>
            </div>
            {p.type === "npc" && (npcs.find((n) => n.id === p.id)?.type === "anonymous") && (
              <button title="Révéler l'identité" onClick={() => onToggleReveal?.(npcs.find((n) => n.id === p.id))} className="sys-label hover:text-[color:var(--r-primary)]">RÉVÉLER</button>
            )}
            <button data-testid={`remove-participant-${p.id}`} onClick={() => removeParticipant(p.id)} className="text-[color:var(--r-text-muted)] hover:text-[color:var(--r-alert)]"><X size={14} /></button>
          </div>
        ))}
      </div>

      <div className="sys-label mb-2 flex items-center gap-1"><UserPlus size={12} /> AJOUTER</div>
      <div className="space-y-2">
        <select className="input font-mono text-xs" value="" onChange={(e) => e.target.value && addParticipant(e.target.value, "npc")}>
          <option value="">+ PNJ…</option>
          {availNpcs.map((n) => <option key={n.id} value={n.id}>{n.name}</option>)}
        </select>
        <select className="input font-mono text-xs" value="" onChange={(e) => e.target.value && addParticipant(e.target.value, "char")}>
          <option value="">+ PERSONNAGE…</option>
          {availChars.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
    </div>
  );
}
